import React, { FC } from 'react';
import { DemandArea } from '../../../../lib/types/endUser';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';
import { getCoveredCategories } from '../../../../lib/utils/end-user-helpers';
import cn from 'classnames';
import { CampaignObjectImage } from '../../../CampaignObjectImage';
import { IconComponent } from '../../../IconComponent';
import { EndUserTypography } from '../../../EndUserTypography';

import AreaTopLeftFrame from '../../../../assets/images/evi-house-mobile-left-rectangle.png';
import AreaTopRightFrame from '../../../../assets/images/evi-house-mobile-right-rectangle.png';

const translation = 'endUser.shared';

type Props = {
  demandAreas?: DemandArea[];
  handleAreaClick: (areaId: number, areaName: string) => void;
  handleKeyDown: (
    event: React.KeyboardEvent<HTMLDivElement>,
    areaId: number,
    areaName: string,
  ) => void;
};

export const EviNewHouseModelMobile: FC<Props> = ({
  demandAreas,
  handleAreaClick,
  handleKeyDown,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <div className={styles.houseTop}>
          {demandAreas?.slice(0, 2).map((area, index) => {
            const isLeft = index === 0;

            const totalCategories = area?.categories.length;
            const coveredCategoriesAmount = getCoveredCategories(
              area?.categories,
            )?.length;

            return (
              <div
                key={area.id}
                role="presentation"
                onClick={() => handleAreaClick(area.id, area.name)}
                onKeyDown={(event) => handleKeyDown(event, area.id, area.name)}
                className={cn(isLeft ? styles.houseTopLeft : styles.houseTopRight)}
              >
                {isLeft && (
                  <img src={AreaTopLeftFrame} alt="frame" className={styles.frame} />
                )}
                {!isLeft && (
                  <img src={AreaTopRightFrame} alt="frame" className={styles.frame} />
                )}

                <div className={styles.iconWrapper}>
                  {area.campaignObject ? (
                    <CampaignObjectImage
                      campaignObject={area.campaignObject}
                      imageClassName={styles.campaignObject}
                      completedIconClassName={styles.campaignObjectCompletedIcon}
                    />
                  ) : (
                    <IconComponent
                      className={styles.icon}
                      color="#fff"
                      iconData={area?.icon}
                    />
                  )}
                </div>

                <EndUserTypography
                  type="headlineSixth"
                  component="Title"
                  className={styles.title}
                  style={{ marginBottom: 0 }}
                >
                  {area.name}
                </EndUserTypography>
                <EndUserTypography
                  type="subText"
                  component="Text"
                  style={{ color: '#fff', textAlign: 'center' }}
                  className={styles.subTitle}
                >
                  {t(`${translation}.coveredCategoriesAmount`, {
                    coveredCategoriesAmount,
                    totalCategories,
                  })}
                </EndUserTypography>
              </div>
            );
          })}
        </div>

        <div className={styles.houseBottom}>
          {demandAreas?.slice(2).map((area, index) => {
            const isLeft = index === 0;
            const totalCategories = area?.categories.length;
            const coveredCategoriesAmount = getCoveredCategories(
              area?.categories,
            )?.length;

            return (
              <div
                key={area.id}
                role="presentation"
                onClick={() => handleAreaClick(area.id, area.name)}
                onKeyDown={(event) => handleKeyDown(event, area.id, area.name)}
                className={cn(isLeft ? styles.houseBottomLeft : styles.houseBottomRight)}
              >
                <div className={styles.iconWrapper}>
                  {area.campaignObject ? (
                    <CampaignObjectImage
                      campaignObject={area.campaignObject}
                      imageClassName={styles.campaignObject}
                    />
                  ) : (
                    <IconComponent
                      className={styles.icon}
                      color="#fff"
                      iconData={area?.icon}
                    />
                  )}
                </div>

                <EndUserTypography
                  type="headlineSixth"
                  component="Title"
                  className={styles.title}
                  style={{ marginBottom: 0 }}
                >
                  {area.name}
                </EndUserTypography>
                <EndUserTypography
                  type="subText"
                  component="Text"
                  style={{ color: '#fff', textAlign: 'center' }}
                  className={styles.subTitle}
                >
                  {t(`${translation}.coveredCategoriesAmount`, {
                    coveredCategoriesAmount,
                    totalCategories,
                  })}
                </EndUserTypography>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
